import { Circle, Flex } from 'components'

interface Props {
  totalSections: number
  currentSection: number
  onClick?: (section: number) => void
  blockedSections?: number[]
}

export default function ProgressIndicator({
  totalSections,
  currentSection,
  onClick,
  blockedSections,
}: Props) {
  return (
    <Flex gap={4} justify="center">
      {Array.from({ length: totalSections }, (_, index) => (
        <Circle
          key={index}
          size="10px"
          bg={index === currentSection ? 'branding.catYellow' : 'rgba(0, 0, 0, 0.2)'}
          onClick={() => (!blockedSections?.includes(index) ? onClick?.(index) : undefined)}
        />
      ))}
    </Flex>
  )
}
